export const optionsEditor = {
	addClosing: false,
	spellCheck: true,
	preserveIdent: false,
	tab: "\t",
};
